"use client";
import {
  AnimatePresence
} from "./chunk-7YLWKTAM.mjs";
import {
  useDatePicker
} from "./chunk-SHF7Y4KF.mjs";

// src/date-picker.tsx
import { useMemo } from "react";
import { cloneElement, isValidElement } from "react";
import { forwardRef } from "@nextui-org/system";
import { Button } from "@nextui-org/button";
import { DateInput, TimeInput } from "@nextui-org/date-input";
import { FreeSoloPopover } from "@nextui-org/popover";
import { Calendar } from "@nextui-org/calendar";
import { CalendarBoldIcon } from "@nextui-org/shared-icons";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function DatePicker(props, ref) {
  const {
    state,
    endContent,
    selectorIcon,
    showTimeField,
    disableAnimation,
    isCalendarHeaderExpanded,
    getDateInputProps,
    getPopoverProps,
    getTimeInputProps,
    getSelectorButtonProps,
    getSelectorIconProps,
    getCalendarProps,
    CalendarTopContent,
    CalendarBottomContent
  } = useDatePicker({ ...props, ref });
  const selectorContent = isValidElement(selectorIcon) ? cloneElement(selectorIcon, getSelectorIconProps()) : /* @__PURE__ */ jsx(CalendarBoldIcon, { ...getSelectorIconProps() });
  const calendarBottomContent = useMemo(() => {
    if (isCalendarHeaderExpanded)
      return null;
    return showTimeField ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(TimeInput, { ...getTimeInputProps() }),
      CalendarBottomContent
    ] }) : CalendarBottomContent;
  }, [state, showTimeField, CalendarBottomContent, isCalendarHeaderExpanded]);
  const calendarTopContent = useMemo(() => {
    if (isCalendarHeaderExpanded)
      return null;
    return CalendarTopContent;
  }, [showTimeField, CalendarTopContent, isCalendarHeaderExpanded]);
  const popoverContent = state.isOpen ? /* @__PURE__ */ jsx(FreeSoloPopover, { ...getPopoverProps(), children: /* @__PURE__ */ jsx(
    Calendar,
    {
      ...getCalendarProps(),
      bottomContent: calendarBottomContent,
      topContent: calendarTopContent
    }
  ) }) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DateInput,
      {
        ...getDateInputProps(),
        endContent: /* @__PURE__ */ jsx(Button, { ...getSelectorButtonProps(), children: endContent || selectorContent })
      }
    ),
    disableAnimation ? popoverContent : /* @__PURE__ */ jsx(AnimatePresence, { children: popoverContent })
  ] });
}
DatePicker.displayName = "NextUI.DatePicker";
var date_picker_default = forwardRef(DatePicker);

export {
  date_picker_default
};
